﻿function UserInfoBalanceData(response) {
    this.balance;
    this.OpenBetsCount;
    this.openedBetsBalanceString;
    this.openFreeBetsBalance;
    this.openFreeBetsBalanceString;
    this.openBalanceString;  // open any bets balance
    this.sportTotalBalance;
    this.sportsbookTotalBalanceString;  // sportsbook total balance
    this.casinoTotalBalance;
    this.casinoTotalBalanceString;      // casino total balance
    this.TotalBalance;
    this.WeeklyCashBalance;
    this.CashBalance;

    this.balanceDataUpdated = false;
    this.openBetsDataUpdated = false;
}

function parceAddtionalBalances(data) {
    try {
        return JSON.parse(CryptoHelper.decrypt(data));
    } catch (e) {
    }
}

UserInfoBalanceData.prototype.updateBalanceData = function (response) {
    if (response.SportsTotalBalance === '' &&
        response.OpenBetsBalanceCustomerCurrency === '' &&
        response.CasinoBalanceCustomerCurrency === '' &&
        response.TotalBalanceCustomerCurrency === '' &&
        !response.AdditionalBalances
    )
    {
        return;
    }

    this.balance = UserInfo.SeamlessCustomerBalance
        ? this.getFormattedBalance(this.sanitizeSeamlessBalance(UserInfo.SeamlessCustomerBalance))
        : response.SportsTotalBalance;
    this.openBetsBalanceCustomerCurrency = response.OpenBetsBalanceCustomerCurrency;
    this.openedBetsBalanceString = this.toUserFormatedCurrencyString(this.openBetsBalanceCustomerCurrency);
    this.sportTotalBalance = this.balance;
    this.sportsbookTotalBalanceString = this.toUserFormatedCurrencyString(this.sportTotalBalance); // sportsbook total balance
    this.casinoTotalBalance = response.CasinoBalanceCustomerCurrency;
    this.casinoTotalBalanceString = this.toUserFormatedCurrencyString(this.casinoTotalBalance); // casino total balance

    this.TotalBalance = UserInfo.SeamlessCustomerBalance ? UserInfo.SeamlessCustomerBalance : response.TotalBalanceCustomerCurrency;
    var additionalBalances = parceAddtionalBalances(response.AdditionalBalances);
    if (additionalBalances)
    {
        this.CasinoRealBalance = additionalBalances[0];
        this.CasinoBonusBalance = additionalBalances[1];
        this.SportsbookBonusBalance = additionalBalances[2];
        this.LockedRealBalanceCustomerCurrency = additionalBalances[3];
        this.LockedBonusBalanceCustomerCurrency = additionalBalances[4];
        this.CreditBalanceCustomerCurrency = additionalBalances[5];
        this.CreditLimitCustomerCurrency = additionalBalances[6];
        this.UsedCreditsCustomerCurrency = additionalBalances[7];
        this.AvailableFundsCustomerCurrency = additionalBalances[8];
        this.CreditIsEnabled = additionalBalances[9];
    }
    this.balanceDataUpdated = true;
    this.updateFullData();
};

UserInfoBalanceData.prototype.updateOpenBets = function (response) {
    this.OpenBetsCount = (response.GetCustomerOpenBetsCountEx);
    this.openFreeBetsBalance = response.OpenFreeBetsBalanceCustomerCurrency;
    this.openFreeBetsBalanceString = this.toUserFormatedCurrencyString(this.openFreeBetsBalance);

    this.openBetsDataUpdated = true;
    this.updateFullData();
};

UserInfoBalanceData.prototype.setBalanceConfigAndCreditLimit = function (balanceConfig, creditLimit) {
    this.balanceConfig = balanceConfig;
    this.creditLimit = creditLimit;
};

UserInfoBalanceData.prototype.updateFullData = function () {
    if (this.balanceDataUpdated && this.openBetsDataUpdated) {
        UserInfo.balancesInitiated = true;
        var openBetsBlanace = this.openBetsBalanceCustomerCurrency + this.openFreeBetsBalance;
        this.openBalanceString = this.toUserFormatedCurrencyString(openBetsBlanace);  // open any bets balance

        if (this.balanceConfig !== BalanceConfig.NONE) {
            var totalBalance = this.balance;
            switch (this.balanceConfig) {
                case BalanceConfig.WEEKLYBALANCE:
                    this.WeeklyCashBalance = ((totalBalance + openBetsBlanace) - this.creditLimit).toStringEx('#.00');
                    break;
                case BalanceConfig.CASHBALANCE:
                    this.CashBalance = ((totalBalance + openBetsBlanace) - this.creditLimit).toStringEx('#.00');
                    break;
                default:
                    break;
            }
        }
    }
};

//Starbet returns the balance separated by comma not by a decimal point
UserInfoBalanceData.prototype.sanitizeSeamlessBalance = function (balance) {
    return  balance.replace(',', '.');
};

UserInfoBalanceData.prototype.getFormattedBalance = function (balance) {
    return '{0:#.00}'.format(parseFloat(balance)); // balance as number
};

window.UserInfoBalanceData = UserInfoBalanceData;
window.parceAddtionalBalances = parceAddtionalBalances;